import type { PaletteOptions } from '@mui/material'
import { colors } from './tokens'

export const palette: PaletteOptions = {
  mode: 'dark',
  primary: { main: colors.gold, dark: colors.goldHover, contrastText: colors.bg },
  secondary: { main: colors.white, contrastText: colors.bg },
  background: { default: colors.bg, paper: colors.surface },
  text: { primary: colors.white, secondary: colors.grey },
  divider: colors.border,
  common: { black: colors.bg, white: colors.white },
}
